<app-ey-app-spinner></app-ey-app-spinner>
<router-outlet></router-outlet>
